import { getColorValue } from '@loomhq/lens';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import { VIDEO_CTA_CLICKED } from 'constants/events';
import * as analytics from 'utilities/analytics';

import './styles.less';

const CustomCtaButton = class extends Component {
  render() {
    const { ctaMods, ctaUrl, ctaText } = this.props;

    let color;
    let background_color;
    let border_radius;

    if (ctaMods) {
      color = ctaMods.color;
      background_color = ctaMods.background_color;
      border_radius = ctaMods.border_radius;
    }

    color = color || getColorValue('white');
    background_color = background_color || getColorValue('orange');

    return (
      <a
        className="cta-button"
        target={ctaUrl && '_blank'}
        rel="noopener noreferrer"
        onClick={this.onClickHandler}
        style={{
          color,
          backgroundColor: background_color,
          borderRadius: `${border_radius}px`,
        }}
        size={ctaText ? ctaText.length : 0}
        href={ctaUrl && (ctaUrl.indexOf('http') > -1 ? ctaUrl : `//${ctaUrl}`)}
      >
        {ctaText ? (
          ctaText
        ) : (
          <span className="call-to-action-placeholder">Call-to-action</span>
        )}
      </a>
    );
  }

  onClickHandler = () => {
    const {
      from_public_share_page,
      is_inline_embed_on_loom,
      parent_location,
      videoId,
      ownerId,
      viewerIsOwner,
      onClick,
    } = this.props;

    onClick && onClick();

    analytics.track(VIDEO_CTA_CLICKED, {
      from_public_share_page,
      is_inline_embed_on_loom,
      parent_location,
      video_id: videoId,
      owner_id: ownerId,
      owner_click: viewerIsOwner,
    });
  };
};

const mapStateToProps = state => {
  const {
    cta_mods: ctaMods,
    cta_text: ctaText,
    cta_url: ctaUrl,
  } = state.share_video;

  const {
    from_public_share_page,
    is_inline_embed_on_loom,
    parent_location,
    video,
  } = state.video_player;

  const { id, owner_id } = video || {};
  const {
    current: { id: viewerId },
  } = state.user;

  return {
    ctaMods,
    ctaText,
    ctaUrl,
    from_public_share_page,
    is_inline_embed_on_loom,
    parent_location,
    videoId: id,
    ownerId: owner_id,
    viewerIsOwner: owner_id === viewerId,
  };
};

export default connect(mapStateToProps)(CustomCtaButton);
